var exports = {
  "k": "x61f99309--25ea37--container",
  "Q": "x61f99309--25ea37--card-link",
};

module.exports = exports;
